/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  MemberDto,
  PagedResultOfMemberBasicInfoDto,
  SearchMemberBasicInfoParams,
  SyncMemberDetails
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Upserts members from Noser app. Invoked by Noser to push newly hired, updated, or reactivated member records.
 */
export const postMembers = (
    syncMemberDetails: SyncMemberDetails,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/member-management/members/sync`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncMemberDetails
    },
      options);
    }
  /**
 * @summary Gets a member details by ID.
 */
export const getMemberDetails = (
    id: string,
 options?: SecondParameter<typeof customInstance<MemberDto>>,) => {
      return customInstance<MemberDto>(
      {url: `/member-management/members/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Gets all members basic info.
 */
export const searchMemberBasicInfo = (
    params?: SearchMemberBasicInfoParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfMemberBasicInfoDto>>,) => {
      return customInstance<PagedResultOfMemberBasicInfoDto>(
      {url: `/member-management/members`, method: 'GET',
        params
    },
      options);
    }
  export type PostMembersResult = NonNullable<Awaited<ReturnType<typeof postMembers>>>
export type GetMemberDetailsResult = NonNullable<Awaited<ReturnType<typeof getMemberDetails>>>
export type SearchMemberBasicInfoResult = NonNullable<Awaited<ReturnType<typeof searchMemberBasicInfo>>>
